import Cookies from "js-cookie";
import { hasTargetingConsent } from "~/helpers/consent";

const _appendScriptTag = (src) => {
  const $script = document.createElement("script");
  $script.async = true;
  $script.src = src;
  document.getElementsByTagName("body")[0].appendChild($script);
};

export const cartEntry = () => {
  if (!hasTargetingConsent()) return;
  const TDID = Cookies.get("ttd_TDID");
  if (TDID) {
    _appendScriptTag(`https://match.adsrvr.org/track/cmf/generic?ttd_pid=${TDID}&ttd_tpi=1`);
  }
};
